// removed by extract-text-webpack-plugin
module.exports = {"isLoading":"_iowG","svgStyleBlock":"_2HIgb","button":"EjSwA","loadingIcon":"POkAn","ieFix":"_1rvcR","edgeFix":"_1ivzn","kgnIcon":"_2kNMl"};


//////////////////
// WEBPACK FOOTER
// ./components/BrandedButton/styles.scss
// module id = 609
// module chunks = 0